<!--
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2022-07-19 09:31:46
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2023-03-31 15:10:41
-->
<template>
  <div class="science-research">
    <div class="science-bj">
      <img class="wid100" :src="require('@/assets/images/m/kyhz/bj.png')" alt="" srcset="">
      <div class="science-bj-txt ">
        <div class="ui-title textc">{{ $t('scienceResearch.title') }}</div>
        <div class="ui-des textc">{{ $t('scienceResearch.des') }}</div>
      </div>
    </div>
    <div class="science-content">
      <!-- 人工智能 -->
      <div class="science-intelligence">
        <div class="science-title">{{ $t('scienceResearch.intelligence.title') }}</div>
        <div class="science-des">{{ $t('scienceResearch.intelligence.des') }}</div>
        <div id="intelligenceSwiper" class="swiper college-swiper">
          <div class="swiper-wrapper">
            <div class="swiper-slide intelligence-item" v-for="(item, index) in $t('scienceResearch.intelligence.list')" :key="index">
              <img class="intelligence-item-bj" :src="require(`@/assets/images/m/kyhz/intelligence${index + 1}.png`)" alt="">
              <div class="intelligence-content center_up_down_left_right">
                <div class="intelligence-title">{{ item.title }}</div>
                <div class="intelligence-des">{{ item.des }}</div>
              </div>
            </div>
          </div>
          <div class="swiper-pagination intelligence-pagination"></div>
        </div>
      </div>
      <!-- 科研合作领域 -->
      <div class="science-field">
        <div class="science-title">{{ $t('scienceResearch.field.title') }}</div>
        <div class="science-des">{{ $t('scienceResearch.field.des') }}</div>
        <div id="fieldSwiper" class="swiper college-swiper">
          <div class="swiper-wrapper">
            <div class="swiper-slide field-item" v-for="(item, index) in $t('scienceResearch.field.list')" :key="index">
              <img class="field-item-bj" :src="require(`@/assets/images/m/kyhz/field${index + 1}.png`)" alt="">
              <div class="field-content">
              <div class="field-title">{{ item.title }}</div>
              <div class="field-des">{{ item.des }}</div>
              </div>
            </div>
          </div>
          <div class="swiper-pagination field-pagination"></div>
        </div>
      </div>
      <!-- 合作意向 -->
      <div class="science-intention">
        <div class="science-title">{{ $t('scienceResearch.intention.title') }}</div>
        <div class="science-des">{{ $t('scienceResearch.intention.des') }}</div>
        <div class="science-intention-form">
          <van-field v-model="formData.name" :label="$t('scienceResearch.intention.form.name')" maxlength="10" disabled colon clearable :label-width="language == 'en' ? '6.2em' : '5.2em'"/>
          <van-field v-model="formData.company" :label="$t('scienceResearch.intention.form.company')" maxlength="20" disabled colon  :label-width="language == 'en' ? '8.8em' : '5.2em'"/>
          <van-field v-model="formData.contact" :label="$t('scienceResearch.intention.form.contact')" maxlength="11" disabled colon  :label-width="language == 'en' ? '11em' : '5.2em'"/>
          <van-field v-model="formData.content" :label="$t('scienceResearch.intention.form.content')" maxlength="100" disabled colon :label-width="language == 'en' ? '12em' : '5.2em'"/>
          <div class="wid100 textc p-b-60 p-t-20">
            <button class="btn" disabled>{{ $t('scienceResearch.intention.form.btn') }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      intelligenceSwiper: null,
      fieldSwiper: null,
      formData: {
        name: '',
        company: '',
        contact: '',
        content: ''
      }
    }
  },
  computed: {
    ...mapGetters(['language'])
  },
  mounted () {
    this.setSwiper('intelligence')
    this.setSwiper('field')
  },
  methods: {
    setSwiper (type) {
      this[`${type}Swiper`] = new this.$Swiper(`#${type}Swiper`, {
        loop: true,
        // autoplay: {
        //   delay: 2000,
        //   disableOnInteraction: false
        // },
        autoplay: false,
        observeParents: true,
        pagination: {
          el: `.${type}-pagination`,
          bulletElement: 'li',
          clickable: true
        }
      })
    }
  },
  beforeDestroy () { // 页面关闭时清除定时器
    this.intelligenceSwiper = null
    this.fieldSwiper = null
  }
}
</script>

<style lang="less" scoped>
@keyframes scale {
  50%,
    100% {
        mask-size: 2000%;
    }
 }
.science-research {
  .science-bj {
    position: relative;
    img{
      margin-bottom: -3PX;
    }
    .science-bj-txt {
      position: absolute;
      right: 30px;
      bottom: 30px;
    }
  }
  .swiper {
    position: relative;
  }
  .swiper-wrapper {
    // overflow: hidden;
  }
  .science-content {
    font-size: 24px;
    line-height: 34px;
    color: #333333;
    .science-title {
      color: #000000;
      font-weight: bold;
      padding-top: 32px;
      font-size: 30px;
      line-height: 42px;
      text-align: center;
    }
    .science-des {
      padding: 14px 50px 30px 50px;
      text-align: center;
    }
    .intelligence-item {
      position: relative;
      overflow: hidden;
      cursor: pointer;
      .intelligence-item-bj {
        width: 100%;
        margin-bottom: -3PX;
      }
      .intelligence-content {
        width: 80%;
        color: #ffffff;
        font-size: 26px;
        line-height: 38px;
        .intelligence-title {
          font-size: 30px;
          line-height: 48px;
          text-align: center;
          padding-bottom: 30px;
          font-weight: bold;
        }
      }
    }
    .field-item {
      position: relative;
      color: #ffffff;
      // height: 578px;
      .field-item-bj {
        width: 100%;
        margin-bottom: -3PX;
      }
      .field-content {
        padding: 30px;
        position: absolute;
        width: 100%;
        top: 20%;
        font-size: 26px;
        line-height: 38px;
        .field-title {
          font-size: 30px;
          line-height: 48px;
          padding-bottom: 44px;
          text-align: center;
        }
      }
    }
  }
}
.m.en {
  .science-research {
    .ui-title {
      font-size: 30px;
    }
    .field-item {
      .field-content {
        top: 6%;
        line-height: 30px;
        .field-title {
          padding-bottom: 34px;
        }
      }
    }
  }
}
</style>

<style lang="less">
.science-research {
  .van-cell {
    padding: 8px 30px;
    line-height: 34px;
    font-size: 24px;
    margin-bottom: 100px;
  }
  .van-field__control {
    height: 60px;
    font-size: 24px;
    line-height: 60px;
    color: #333333;
  }
  .van-field__label {
    font-size: 24px;
    color: rgba(51, 51, 51, 0.4);
    margin-right: 0;
    line-height: 60px;
  }
  .btn {
    min-width: 296px;
    height: 80px;
    border-radius: 40px;
    border-color:rgba(0, 0, 0, 0.3);
    color: #333333;
    font-size: 26px;
    padding: 0 23px;
    line-height: 78px;
    &[disabled] {
      border-color:rgba(0, 0, 0, 0.1);
      color: rgba(51, 51, 51, 0.2);
      cursor: none;
    }
  }
  .swiper-pagination {
    padding-left: 13px;
    bottom: 30px;
    width: 100%;
    z-index: 5;
    .swiper-pagination-bullet {
      background: rgba(151, 151, 151, 0.5);
      width: 16px;
      height: 16px;
      margin: 0 12px;
      opacity: 1;
    }
    .swiper-pagination-bullet-active {
      background: #ffffff;
    }
  }
}
</style>
